// src/components/Footer.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Footer.css';

export default function Footer({ onDeveloperClick }) {
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  const scrollToSection = (e, sectionId) => {
    if (!isHomePage) return;

    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="footerBand">
      <footer className="container footer">
        <div className="foot-left">
          <div>© {new Date().getFullYear()} Your Highest Self</div>
        </div>
        <nav className="foot-right">
          {onDeveloperClick && (
            <button
              onClick={onDeveloperClick}
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                padding: 0,
                font: 'inherit',
                textDecoration: 'none',
                opacity: 0.7,
                transition: 'opacity 0.2s ease',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.opacity = '1';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.opacity = '0.7';
              }}
            >
              Developer
            </button>
          )}
          {isHomePage ? (
            <a href="#about" onClick={(e) => scrollToSection(e, 'about')}>
              About
            </a>
          ) : (
            <Link to="/#about">About</Link>
          )}
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </footer>
    </div>
  );
}
